/* eslint-disable */
import { Button, FormHelperText, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import OpacityIcon from '@material-ui/icons/Opacity';
import RemoveIcon from '@material-ui/icons/Remove';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_SLUMP_SELECTOR_DECREASE, UI_SLUMP_SELECTOR_INCREASE } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import placeOrderStyles from './PlaceOrder.component.styles';

// as component is redrawn every single time, state will be not usefull as will get reset every render. Thats why we using those vars in here to keep track if modal confirmation should be displayed or not. To refresh we fake "forceUpdate" by using state. Not very elegant but the only way I can think of at the moment
let isConfirmed = false;
let showConfirm = false;

/**
 * SlumpSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const SlumpSelector = ({ actions, classes, enteredSlump, product, onChange, noSlump, disabled, mandatoryFieldError }) => {
  let slump = enteredSlump;
  if (!slump) {
    slump = product ? product.slump : 0;
  }

  const [, forceUpdate] = useState(false);

  /**
   * Increase slump
   * @returns {void} void
   */
  const increase = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `slumpSelectorIncrease`,
        },
      },
      type: UI_SLUMP_SELECTOR_INCREASE,
    });

    if (slump < product.slump) {
      onChange({ slump: slump + 10, isValid: true });
    }
    return;
  };

  /**
   * Decrease slump
   * @returns {void} void
   */
  const decrease = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `slumpSelectorDecrease`,
        },
      },
      type: UI_SLUMP_SELECTOR_DECREASE,
    });

    if (slump > product.slump - 10) {
      onChange({ slump: slump - 10, isValid: true });
    }
    return;
  };

  let slumpValue = noSlump ? `n/a` : slump || ``;
  if (disabled) {
    slumpValue = enteredSlump;
  }

  return (
    <React.Fragment>
      <Modal
        preventFullScreen
        content={<Typography variant="body2">Are you sure you want to change the recommended slump?</Typography>}
        onClose={() => {}}
        open={showConfirm}
        paperClasses={classes.paperClasses}
        footer={
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  isConfirmed = true;
                  showConfirm();
                  showConfirm = false;
                  forceUpdate(2);
                }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={() => {
                  showConfirm = false;
                  forceUpdate(2);
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="center" className={classes.flexWrapNowrap}>
            <Grid item className={classes.flexGrow1}>
              <TextField
                error={mandatoryFieldError}
                disabled={disabled}
                fullWidth
                id="slump"
                value={slumpValue}
                label="Slump"
                className={classes.quantityField}
                placeholder="0.0"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <OpacityIcon className={classes.opacity05} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="body1">slump</Typography>
                    </InputAdornment>
                  ),
                }}
              />
              {!disabled && <FormHelperText>Recommended slump is based on your product configuration</FormHelperText>}
            </Grid>
            {!noSlump && !disabled && (
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => {
                    if (!isConfirmed) {
                      showConfirm = decrease;
                      forceUpdate(1);
                    } else {
                      decrease();
                    }
                  }}
                >
                  <RemoveIcon />
                </Button>
              </Grid>
            )}
            {!noSlump && !disabled && (
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => {
                    if (!isConfirmed) {
                      showConfirm = increase;
                      forceUpdate(1);
                    } else {
                      increase();
                    }
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
SlumpSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  enteredSlump: PropTypes.number,
  product: PropTypes.object,
  disabled: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(SlumpSelector);
